<template>
  <v-card class="mb-5">
    <v-card-title>
      Отчет все показатели пользователя(первый и последний) среднее

      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Поиск" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :loading="loading" :headers="headers" :items="items" :items-per-page="15" :search="search"></v-data-table>
  </v-card>
</template>

<script>
import reportData from "@/moks/reportAllUserMetrics.json";

export default {
  name: "MetricReport",

  data: () => ({
    loading: false,
    search: "",
    headers: [
      {
        text: "Показатель",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "Замеров",
        align: "start",
        sortable: false,
        value: "measurements",
      },
      {
        text: "Начальное среднее",
        align: "start",
        sortable: false,
        value: "initial_secondary",
      },
      {
        text: "Конечное среднее",
        align: "start",
        sortable: false,
        value: "final_mean",
      },
    ],
    items: reportData,
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  async created() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        const response = await this.$http.get(`v1/customers/${this.customerId}/all-metrics-report`, {
          params: {
            measurements_count: 5,
            language: "ru",
          },
        });
        this.items = response.data.data;
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e.response);

        this.items = [];
        this.meta.total = 0;
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
